import * as types from "../actions/actionTypes";
import createEntityReducer from "./createEntityReducer";

export default createEntityReducer({
  entity: "orderdispatch",
  listKey: "dispatches",
  itemKey: "dispatch",
  getAll: types.GET_ALL_ORDER_DISPATCHS,
  getAllResponse: types.GET_ALL_ORDER_DISPATCHS_RESPONSE,
  getByIdResponse: types.GET_ORDER_DISPATCH_BY_ID_RESPONSE,
});
